import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { list_services_page, services } from "../data/services";
import { FaArrowRight } from "react-icons/fa";
function Services() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <motion.div
      ref={ref}
      className="w-full py-16 px-6 md:px-12 lg:px-16"
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={containerVariants}
    >
      {/* Outer Container */}
      <div className="max-w-7xl mx-auto bg-blue-50 px-4 py-10 lg:px-10  rounded-xl">
        {/* Title Section */}
        <motion.div
          className="mb-12 text-center"
          variants={{
            hidden: { opacity: 0, y: -20 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
          }}
        >
          <h2 className="text-4xl font-extralight text-customAqua600">
            Services
          </h2>
          <p className="text-lg font-thin text-customAqua600 mt-4">
            Découvrez nos services dentaires qui répondent à tous vos besoins.
          </p>
        </motion.div>

        {/* Cards Grid */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={containerVariants}
        >
          {list_services_page.map((service, index) => (
            <motion.div
              key={index}
              className="relative flex flex-col justify-center"
              variants={cardVariants}
            >
              <div className="h-[450px] group relative cursor-pointer overflow-hidden bg-white px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl sm:max-w-sm rounded-lg sm:px-10">
                {/* Background Image */}
                <div
                  className="absolute inset-0 z-0 transition-opacity duration-300 opacity-0 bg-cover bg-center group-hover:opacity-100"
                  style={{
                    backgroundImage: `url('${service.imagePath}')` ,
                  }}
                ></div>
                {/* Main Content */}
                <div className="relative z-10 mx-auto max-w-md">
                  <span className="mb-4 pt-2 flex h-20 w-20 justify-center items-center rounded-full bg-sky-500 transition-all duration-300 group-hover:bg-sky-400">
                    {service.icon}
                  </span>
                  <div className="px-1 pt-5 text-xl font-normal leading-7 text-customAqua600 group-hover:text-customAqua600 group-hover:bg-white/40">
                    <p>{service.title}</p>
                  </div>
                  <div className="p-1 mb-2 space-y-6 pt-5 text-sm font-normal leading-2 text-customAqua600 transition-all duration-300 group-hover:text-customAqua600 group-hover:bg-white/40">
                    <p>{service.description}</p>
                  </div>
                  <button className="flex flex-row items-center justify-center px-1 pt-5 text-xl font-extralight leading-7 text-customAqua600 group-hover:text-customAqua600 group-hover:bg-white/40">
                    <a href={`/services/${service.id}`} className="flex flex-row justify-center items-center" alt="Service item">
                      Voir Plus <FaArrowRight className="ml-4 w-4 h-4" />
                    </a>
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
}

export default Services;
